<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import '@/plugins/highcharts.js'
import { useCoreStore } from '@/stores/core'

export default {
  name: 'TravelsPurposesDistancesBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  setup () {
    let coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    purposes: function () {
      return this.coreStore.travelPurposeLabels
    },
    values: function () {
      let i = 0
      let values = { distance: '<nobr>' + this.$t('distances.km') + '</nobr>' }
      for (let purpose of this.purposes) {
        values[this.$t(purpose)] = this.$options.filters.splitNumber(
          this.ghgi.emissions.travels.purposes.distances[i]
        )
        i += 1
      }
      return [values]
    },
    columns: function () {
      let columns = [
        {
          field: 'distance',
          label: '',
          sticky: true
        }
      ]
      for (let purpose of this.purposes) {
        columns.push({
          field: this.$t(purpose),
          label: this.$t(purpose),
          numeric: true
        })
      }
      return columns
    },
    series: function () {
      return [
        {
          name: this.$t('distances.km'),
          data: this.ghgi.emissions.travels.purposes.distances.map((value) =>
            Math.round(value)
          )
        }
      ]
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        series: this.series,
        xAxis: {
          categories: this.purposes.map((val) => this.$t(val)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('distances.km')
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: ' ' + this.$t('km')
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
